import { type RawAppInfo } from 'api/types/AppInfo/RawAppInfo';

import { unifiedAppParser } from './unifiedAppParser';

// TODO: TEMP type fix (7348786289)
type TempExhibitionFix = {
  id: string;
  title: string;
  tiles: {
    icon: string;
    company_id: string;
    title: string;
    category: string;
  }[];
};

// TODO: Finish parsing (7348786289)
export const parseShowcaseData = (data: RawAppInfo & { exhibitions: TempExhibitionFix[] }) => {
  const app = unifiedAppParser(data);

  return {
    ...app,
    exhibitions: data.exhibitions,
  };
};
